import React, { Fragment, useState, useEffect, useContext, useCallback } from "react";
import { useParams } from "react-router-dom";
import SEO from "../../SEO";
import { ProductDetailsContext } from "./index";
import { LayoutContext } from "../index";
import { useHistory } from "react-router-dom";
import Submenu from "./Submenu";
import ProductDetailsSectionTwo from "./ProductDetailsSectionTwo";

import { getSingleProduct } from "./FetchApi";
import { cartListProduct } from "../partials/FetchApi";
import { getAllProduct } from "../../admin/products/FetchApi"; // Assure-toi que ce chemin est correct

import { isWishReq, unWishReq, isWish } from "../home/Mixins";
import { updateQuantity, slideImage, cartList } from "./Mixins";
import { totalCost } from "../partials/Mixins";
import { getRandomFallbackImage } from "../../../utils/randomImage";
import { useCart } from "../../../contexts/CartContext";

const apiURL = process.env.REACT_APP_API_URL;

const ProductDetailsSection = () => {
  let { id } = useParams();

  const { data, dispatch } = useContext(ProductDetailsContext);
  const { data: layoutData, dispatch: layoutDispatch } =
    useContext(LayoutContext);
  const { addToCart } = useCart();

  const sProduct = layoutData.singleProductDetail;
  const [pImages, setPimages] = useState(null);
  const [count, setCount] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [, setAlertq] = useState(false);
  const [wList, setWlist] = useState(JSON.parse(localStorage.getItem("wishList")));
  const history = useHistory();

  // 🔥 Nouvel état pour les produits similaires
  const [similarProducts, setSimilarProducts] = useState([]);

  // ✅ Fonction principale pour récupérer le produit (memoïsé pour l'ESLint)
  const fetchData = useCallback(async () => {
    dispatch({ type: "loading", payload: true });
    try {
      let responseData = await getSingleProduct(id);
      setTimeout(() => {
        if (responseData.Product) {
          layoutDispatch({
            type: "singleProductDetail",
            payload: responseData.Product,
          });
          setPimages(responseData.Product.pImages);
          dispatch({ type: "loading", payload: false });
          layoutDispatch({ type: "inCart", payload: cartList() });

          // 🔥 Appel séparé pour les produits similaires
          fetchSimilarProducts(responseData.Product);
        }
        if (responseData.error) {
          console.log(responseData.error);
        }
      }, 500);
    } catch (error) {
      console.log(error);
    }
    fetchCartProduct();
  }, [dispatch, getSingleProduct, id, layoutDispatch]);

  useEffect(() => {
    fetchData();
    window.scrollTo(0, 0);
  }, [fetchData]);

  // ✅ Fonction pour récupérer les produits similaires
  const fetchSimilarProducts = async (product) => {
    try {
      const allProducts = await getAllProduct();
      if (allProducts && allProducts.Products) {
        const price = product.pPrice;
        const filtered = allProducts.Products.filter(
          (p) =>
            p._id !== product._id &&
            Math.abs(p.pPrice - price) <= price * 0.35 // ±20% du prix
        ).slice(0, 4); // Limite à 4 produits
        setSimilarProducts(filtered);
      }
    } catch (error) {
      console.log("Erreur lors de la récupération des produits similaires:", error);
    }
  };


  const fetchCartProduct = async () => {
    try {
      let responseData = await cartListProduct();
      if (responseData && responseData.Products) {
        layoutDispatch({ type: "cartProduct", payload: responseData.Products });
      }
    } catch (error) {
      console.log(error);
    }
  };

  if (data.loading) {
    return (
      <div className="col-span-2 md:col-span-3 lg:col-span-4 flex items-center justify-center h-screen">
        <img
          className="w-12 h-12 animate-spin text-yellow-600"
          fill="none"
          stroke="currentColor"
           src="/images/favicon.png"
          alt="loading"
        />
      </div>
    );
  } else if (!sProduct) {
    return <div>Aucun produit</div>;
  }
  
  // Calculer le prix avec réduction
  const offer = parseInt(sProduct.pOffer, 10) || 0;
  const basePrice = Number(sProduct.pPrice) || 0;
  const discountedPrice = offer > 0
    ? Math.max(0, Math.round(basePrice * (1 - offer / 100)))
    : basePrice;
  
  // Préparer les données SEO du produit
  const productSEO = {
    name: sProduct.pName,
    description: sProduct.pDescription,
    price: discountedPrice,
    image: `${apiURL}/uploads/products/${sProduct.pImages?.[0]}`,
    inStock: sProduct.pQuantity > 0,
    rating: sProduct.pRatingsReviews?.length > 0 ? {
      value: (sProduct.pRatingsReviews.reduce((sum, r) => sum + parseInt(r.rating), 0) / sProduct.pRatingsReviews.length).toFixed(1),
      count: sProduct.pRatingsReviews.length
    } : null
  };
  
  return (
    <Fragment>
      <SEO 
        title={`${sProduct.pName} - Parfum Authentique | JamaalStore Sénégal`}
        description={`${sProduct.pDescription.substring(0, 155)}... Livraison rapide à Dakar et partout au Sénégal. ${discountedPrice.toLocaleString()} FCFA`}
        keywords={`${sProduct.pName}, parfum ${sProduct.pCategory?.cName}, ${sProduct.pCategory?.cName} Sénégal, parfum authentique, acheter parfum Dakar, ${offer > 0 ? 'promotion parfum,' : ''} JamaalStore`}
        url={`https://jamaalstore.com/products/${sProduct._id}`}
        image={`${apiURL}/uploads/products/${sProduct.pImages?.[0]}`}
        type="product"
        product={productSEO}
      />
      <Submenu
        value={{
          categoryId: sProduct.pCategory._id,
          product: sProduct.pName,
          category: sProduct.pCategory.cName,
        }}
      />
      <section className="m-4 md:mx-12 md:my-6">
        <div className="grid grid-cols-2 md:grid-cols-12">
          <div className="hidden md:block md:col-span-1 md:flex md:flex-col md:space-y-4 md:mr-2">
            <img
              onClick={(e) =>
                slideImage("increase", 0, count, setCount, pImages)
              }
              className={`${
                count === 0 ? "" : "opacity-25"
              } cursor-pointer w-20 h-20 object-cover object-center`}
              src={`${apiURL}/uploads/products/${sProduct.pImages[0]}`}
              alt="pic"
              onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = getRandomFallbackImage(); }}
            />
            <img
              onClick={(e) =>
                slideImage("increase", 1, count, setCount, pImages)
              }
              className={`${
                count === 1 ? "" : "opacity-25"
              } cursor-pointer w-20 h-20 object-cover object-center`}
              src={`${apiURL}/uploads/products/${sProduct.pImages[1]}`}
              alt="pic"
              onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = getRandomFallbackImage(); }}
            />
          </div>
          <div className="col-span-2 md:col-span-7">
            <div className="relative">
            <img
              className="w-full h-42  lg:w-32 lg:h-32 object-cover object-center rounded"
              src={`${apiURL}/uploads/products/${sProduct.pImages[count]}`}
              alt="Pic"
              onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = getRandomFallbackImage(); }}
            />

              <div className="absolute inset-0 flex justify-between items-center mb-4">
                <svg
                  onClick={(e) =>
                    slideImage("increase", null, count, setCount, pImages)
                  }
                  className="flex justify-center  w-12 h-12 text-gray-700 opacity-25 cursor-pointer hover:text-yellow-700 hover:opacity-100"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
                <svg
                  onClick={(e) =>
                    slideImage("increase", null, count, setCount, pImages)
                  }
                  className="flex justify-center  w-12 h-12 text-gray-700 opacity-25 cursor-pointer hover:text-yellow-700 hover:opacity-100"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div className="col-span-2 mt-8 md:mt-0 md:col-span-4 md:ml-6 lg:ml-12">
            <div className="flex flex-col leading-8">
              <div className="text-2xl tracking-wider">{sProduct.pName}</div>
              <div className="flex justify-between items-center">
                <span className="text-xl tracking-wider text-yellow-700">
                  {sProduct.pPrice}F CFA
                </span>
                <span>
                  <svg
                    onClick={(e) => isWishReq(e, sProduct._id, setWlist)}
                    className={`${
                      isWish(sProduct._id, wList) && "hidden"
                    } w-5 h-5 md:w-6 md:h-6 cursor-pointer text-yellow-700`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                    />
                  </svg>
                  <svg
                    onClick={(e) => unWishReq(e, sProduct._id, setWlist)}
                    className={`${
                      !isWish(sProduct._id, wList) && "hidden"
                    } w-5 h-5 md:w-6 md:h-6 cursor-pointer text-yellow-700`}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
              </div>
            </div>
            <div className="my-4 md:my-6 text-gray-600">
              {sProduct.pDescription}
            </div>
            <div className="my-4 md:my-6">
              {+quantity === +sProduct.pQuantity ? (
                <span className="text-xs text-red-500">Stock limité</span>
              ) : (
                ""
              )}
              <div
                className={`flex justify-between items-center px-4 py-2 border ${
                  +quantity === +sProduct.pQuantity && "border-red-500"
                }`}
              >
                <div
                  className={`${
                    quantity === sProduct.pQuantity && "text-red-500"
                  }`}
                >
                  Quantité
                </div>
                {/* Quantity Button */}
                {sProduct.pQuantity !== 0 ? (
                  <Fragment>
                    {layoutData.inCart == null ||
                    (layoutData.inCart !== null &&
                      layoutData.inCart.includes(sProduct._id) === false) ? (
                      <div className="flex items-center space-x-2">
                        <span
                          onClick={(e) =>
                            updateQuantity(
                              "decrease",
                              sProduct.pQuantity,
                              quantity,
                              setQuantity,
                              setAlertq
                            )
                          }
                        >
                          <svg
                            className="w-5 h-5 fill-current cursor-pointer"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </span>
                        <span className="font-semibold">{quantity}</span>
                        <span
                          onClick={(e) =>
                            updateQuantity(
                              "increase",
                              sProduct.pQuantity,
                              quantity,
                              setQuantity,
                              setAlertq
                            )
                          }
                        >
                          <svg
                            className="w-5 h-5 fill-current cursor-pointer"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </span>
                      </div>
                    ) : (
                      <div className="flex items-center space-x-2">
                        <span>
                          <svg
                            className="w-5 h-5 fill-current cursor-not-allowed"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </span>
                        <span className="font-semibold">{quantity}</span>
                        <span>
                          <svg
                            className="w-5 h-5 fill-current cursor-not-allowed"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </span>
                      </div>
                    )}
                  </Fragment>
                ) : (
                  <div className="flex items-center space-x-2">
                    <span>
                      <svg
                        className="w-5 h-5 fill-current cursor-not-allowed"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </span>
                    <span className="font-semibold">{quantity}</span>
                    <span>
                      <svg
                        className="w-5 h-5 fill-current cursor-not-allowed"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </span>
                  </div>
                )}
                {/* Quantity Button End */}
              </div>
              {/* Incart and out of stock button */}
              {sProduct.pQuantity !== 0 ? (
                <Fragment>
                  <div
                    onClick={() => addToCart({
                      ...sProduct,
                      quantity: quantity
                    })}
                    style={{ background: "#1E344D" }}
                    className={`px-4 py-2 text-white text-center cursor-pointer uppercase hover:opacity-90 transition-opacity`}
                  >
                    Ajouter au panier
                  </div>
                </Fragment>
              ) : (
                <Fragment>
                  <div
                    style={{ background: "#1E344D" }}
                    disabled={true}
                    className="px-4 py-2 text-white opacity-50 cursor-not-allowed text-center uppercase"
                  >
                    En rupture de Stock
                  </div>
                </Fragment>
              )}
              {/* Incart and out of stock button End */}
            </div>
          </div>
        </div>
      </section>
      {/* Product Details Section two */}
      <ProductDetailsSectionTwo />
      {/* Produits Similaires */}
      {similarProducts.length > 0 && (
        <section className="m-4 md:mx-12 md:my-6">
          <h2 className="text-xl text-blue-800 font-semibold mb-4">Produits similaires</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {similarProducts.map((prod) => (
              <div
                key={prod._id}
                onClick={() => history.push(`/products/${prod._id}`)} 
                className="border rounded-lg p-2 shadow hover:shadow-lg transition cursor-pointer"
              >
                <img
                  className="w-full h-40 object-cover rounded"
                  src={`${apiURL}/uploads/products/${prod.pImages[0]}`}
                  alt={prod.pName}
                />
                <div className="mt-2">
                  <h3 className="font-medium">{prod.pName}</h3>
                  <p className="text-yellow-700">{prod.pPrice} F CFA</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

    </Fragment>
  );
};

export default ProductDetailsSection;
